import { AfterViewInit, Component, ElementRef, inject, input, viewChild } from '@angular/core';

import { ModalService } from '../../../services';
import { BackButtonComponent } from '../../back-button/back-button.component';

@Component({
  selector: 'app-discard-changes-modal',
  templateUrl: './discard-changes-modal.component.html',
  styleUrl: './discard-changes-modal.component.scss',
  imports: [BackButtonComponent],
})
export class DiscardChangesModalComponent implements AfterViewInit {
  private readonly modalService = inject(ModalService);

  private readonly focus = viewChild<ElementRef<HTMLButtonElement>>('focus');

  public readonly header = input<string>();
  public readonly message = input<string>();

  ngAfterViewInit(): void {
    this.focus().nativeElement.focus();
  }

  onYes() {
    this.modalService.close(true);
  }

  onNo() {
    this.modalService.close(false);
  }

  back() {
    this.modalService.dismiss();
  }
}
